module.exports = __webpack_public_path__ + "img/download(2).2b4d57c2.png";